export function getWorkers(state) {
  return state.workers;
}